<template>
	<div>
		<!-- Front & Back the same with 1 or more options -->
		<div v-if="options[0].back == '(Same as front tyre)' && options.length >= 1" class="row">
			<div class="col-12">
				<h4 class="tyre-size-label text-start">Front &amp; Rear sizes</h4>
			</div>
		</div>

		<!-- Different Front and Back sizes with 1 or more options -->
		<div v-if="options[0].back != '(Same as front tyre)' && options.length >= 1" class="row">
			<div class="col-6">
				<h4 class="tyre-size-label text-start">Front sizes</h4>
			</div>
			<div class="col-6">
				<h4 class="tyre-size-label text-start">Rear sizes</h4>
			</div>
		</div>
	</div>
</template>
<script>
    export default {
	    props: ['options'],
	    components: {
	    },
	    data() {
	        return {
	        }
	    },
	    mounted() {

	    },
	    methods: {
	    },
	    computed: {

	    }
	}
</script>
<style lang="scss">
</style>